import { SHOW_AWARD, HIDE_AWARD, SET_CURRENT_CARD, HIDE_BACKGROUND_OF_AWARD } from '../types/award';

export const initialState = {
  showAward: false,
  showBackgroundOfAward: false,
  currentCard: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_AWARD:
      return { ...state, showAward: true, showBackgroundOfAward: true };
    case HIDE_AWARD:
      return { ...state, showAward: false, showBackgroundOfAward: false };
    case HIDE_BACKGROUND_OF_AWARD:
      return { ...state, showBackgroundOfAward: false };
    case SET_CURRENT_CARD:
      return { ...state, currentCard: action.payload };
    default:
      return state;
  }
};
